/* Amabile Promo Code Feature — global flow */
(function () {
  'use strict';

  var STORAGE_KEY = 'amabilePromoCode';
  var DURATION_MS = 10 * 60 * 1000; // 10 minutes
  var URGENT_THRESHOLD_S = 120;     // last 2 minutes turn pink
  var HASHED_CODES = window.__promoHashedCodes || [];
  var N8N_VALIDATE_URL = 'https://n8n.srv1121475.hstgr.cloud/webhook/promocheck';
  var SHOPIFY_WEBHOOK_URL = 'https://flow-webhooks.k8s.eu.codecreationlabs.cloud/webhook/2npuyrga';

  /* Reads the logged-in customer's ID from the `amabile_customer_id` cookie,
     which is written by a Shopify Custom Pixel. Returns null when absent. */
  function getCustomerId() {
    var m = document.cookie.match(/(?:^|;\s*)amabile_customer_id=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ─── Discounted price overlay ─── */
  var DISCOUNT_RATE = 0.8; // 20% off
  var PRICE_SELECTORS = [
    '.grid-product__price .sale-price',
    '.grid-product__price--original',
    '.grid-product__price',
    '[data-product-price]',
    '[data-compare-price]'
  ].join(',');

  // Parse a formatted money string ("€25,90", "$25.90", "1.299,50 €") into cents.
  // Returns { cents, prefix, suffix, decimalSep } so we can format back identically.
  function parseMoney(str) {
    var s = String(str).trim();
    if (!s) return null;
    var match = s.match(/[\d.,\s]+/);
    if (!match) return null;
    var numStr = match[0].trim();
    var prefix = s.slice(0, match.index);
    var suffix = s.slice(match.index + match[0].length);

    // Detect decimal separator: the LAST '.' or ',' followed by 1-2 digits is the decimal.
    var decSep = '.';
    var lastDot = numStr.lastIndexOf('.');
    var lastComma = numStr.lastIndexOf(',');
    if (lastComma > lastDot) decSep = ',';
    var thouSep = decSep === ',' ? '.' : ',';

    // Strip thousands separators, normalise decimal to '.'
    var clean = numStr.split(thouSep).join('').split(/\s/).join('').replace(decSep, '.');
    var n = parseFloat(clean);
    if (isNaN(n)) return null;
    return { cents: Math.round(n * 100), prefix: prefix, suffix: suffix, decimalSep: decSep };
  }

  function formatMoney(cents, decimalSep, prefix, suffix) {
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100).padStart(2, '0');
    return prefix + whole + decimalSep + frac + suffix;
  }

  var DISCOUNT_RATE_10 = 0.9; // 10% off (for "promo-10" tagged products)

  function applyDiscountToEl(el) {
    if (!el || el.dataset.promoApplied) return;
    // Skip products tagged "no-promo" (PLP card or PDP wrapper marked in Liquid).
    if (el.closest('[data-no-promo]')) return;
    var raw = el.textContent;
    var parsed = parseMoney(raw);
    if (!parsed || parsed.cents <= 0) return;

    // Products tagged "promo-10" get 10% off instead of 20%
    var rate = el.closest('[data-promo-10]') ? DISCOUNT_RATE_10 : DISCOUNT_RATE;
    var newCents = Math.round(parsed.cents * rate);
    var newDisplay = formatMoney(newCents, parsed.decimalSep, parsed.prefix, parsed.suffix);

    // Save original so we can restore if we ever need to
    el.dataset.promoOrig = raw;
    el.innerHTML =
      '<s class="promo-orig">' + escapeHtml(raw.trim()) + '</s>' +
      '<span class="promo-new">' + escapeHtml(newDisplay) + '</span>';
    el.dataset.promoApplied = '1';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function applyDiscountDisplay() {
    var els = document.querySelectorAll(PRICE_SELECTORS);
    for (var i = 0; i < els.length; i++) applyDiscountToEl(els[i]);
  }

  var root, fab, backdrop, drawer, input, submit, errorEl, form;
  var celebration, confettiCanvas, banner, bannerLabel, bannerTimer;
  var countdownInterval, celebrationTimeout, confettiRaf;

  function $(sel) { return root.querySelector(sel); }

  function pad(n) { return String(n).padStart(2, '0'); }

  function formatTime(s) {
    var m = Math.floor(s / 60);
    return pad(m) + ':' + pad(s % 60);
  }

  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.expiresAt !== 'number') return null;
      if (parsed.expiresAt <= Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (_e) { return null; }
  }

  function writeState(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_e) {}
  }

  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_e) {}
  }

  /* ─── Drawer ─── */
  function openDrawer() {
    backdrop.classList.add('promo-code__backdrop--open');
    drawer.classList.add('promo-code__drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    input.value = '';
    setError('');
    setTimeout(function () { input.focus(); }, 350);
  }

  function closeDrawer() {
    backdrop.classList.remove('promo-code__backdrop--open');
    drawer.classList.remove('promo-code__drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function setError(msg) {
    errorEl.textContent = msg || '';
    if (msg) input.classList.add('promo-code__input--error');
    else input.classList.remove('promo-code__input--error');
  }

  function setSubmitting(on) {
    submit.disabled = on;
    submit.textContent = on ? '...' : (submit.dataset.label || 'Applica');
  }

  /* ─── Validation (hash-based, codes never exposed) ─── */
  function sha256(str) {
    var buf = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buf).then(function (hash) {
      return Array.from(new Uint8Array(hash)).map(function (b) {
        return b.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function applyCode() {
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { setError('Inserisci un codice promozionale'); return; }

    var customerId = getCustomerId();
    if (!customerId) { setError('Devi accedere al tuo account per attivare la promozione.'); return; }

    setSubmitting(true);
    setError('');

    sha256(code).then(function (hash) {
      if (HASHED_CODES.indexOf(hash) === -1) {
        setSubmitting(false);
        setError('Codice non valido. Riprova.');
        return;
      }
      checkUsage(customerId, code);
    });
  }

  function checkUsage(customerId, code) {
    fetch(N8N_VALIDATE_URL, {
      method: 'post',
      body: new URLSearchParams({ customer_id: customerId, promo_code: code })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { 
        setSubmitting(false);
        if (data.valid) {
          notifyShopifyWebhook(customerId, code);
          activateDiscount(code);
        } else {
          setError(data.message || 'Codice non valido. Riprova.');
        }
      })
      .catch(function () {
        setSubmitting(false);
        setError('Errore di connessione. Riprova.');
      });
  }

  function notifyShopifyWebhook(customerId, code) {
    fetch(SHOPIFY_WEBHOOK_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, promo_code: code })
    }).catch(function () {});
  }

  function activateDiscount(code) {
    var expiresAt = Date.now() + DURATION_MS;
    writeState({ code: code, expiresAt: expiresAt });

    closeDrawer();
    document.body.classList.add('promo-active');
    runCelebration(function () {
      hideFab();
      showBanner();
      startCountdown();
      applyDiscountDisplay();
      // Drop Shopify's discount cookie so the code auto-applies at checkout.
      // redirect:'manual' prevents following the 302 — cookie still gets set
      // from response headers, but we avoid the side-effects of the redirect
      // (which can corrupt the dev server session and break /cart/add.js).
      fetch('/discount/' + encodeURIComponent(code) + '?t=' + Date.now(), {
        method: 'GET',
        redirect: 'manual',
        credentials: 'same-origin'
      }).catch(function () { /* opaque redirect rejects — ignore */ });
    });
  }

  /* ─── Celebration ─── */
  function runCelebration(onDone) {
    celebration.classList.add('promo-code__celebration--visible');
    startAquarium();
    if (celebrationTimeout) clearTimeout(celebrationTimeout);
    celebrationTimeout = setTimeout(function () {
      celebration.classList.remove('promo-code__celebration--visible');
      confettiCanvas.style.transition = 'opacity 1.7s ease-out';
      confettiCanvas.style.opacity = '0';
      setTimeout(function () {
        stopAquarium();
        confettiCanvas.style.transition = '';
        confettiCanvas.style.opacity = '';
        if (typeof onDone === 'function') onDone();
      }, 3500);
    }, 4200);
  }

  function startAquarium() {
    var canvas = confettiCanvas;
    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.scale(dpr, dpr);

    var w = window.innerWidth, h = window.innerHeight;
    var PI = Math.PI, TAU = PI * 2, rnd = Math.random;
    var cx = w / 2, friction = 0.99;

    function burst(speed) {
      var a = -(rnd() * PI);
      return {
        x: cx + (rnd() - 0.5) * w * 0.06,
        y: h + rnd() * 15,
        vx: Math.cos(a) * speed,
        vy: Math.sin(a) * speed
      };
    }

    /* ── Particle pools — all burst from bottom-center ── */
    var bubbles = [];
    for (var i = 0; i < 65; i++) {
      var b = burst(rnd() * 7 + 2);
      bubbles.push({
        x: b.x, y: b.y, vx: b.vx, vy: b.vy,
        r: rnd() * 24 + 4,
        wF: rnd() * 0.02 + 0.004, wA: rnd() * 20 + 5,
        ph: rnd() * TAU,
        hue: rnd() * 60 + 180
      });
    }

    var pearlColors = ['#F3F1EF', '#EAC7CA', '#F5E6C8'];
    var pearls = [];
    for (var i = 0; i < 14; i++) {
      var b = burst(rnd() * 5 + 2);
      pearls.push({
        x: b.x, y: b.y, vx: b.vx, vy: b.vy,
        r: rnd() * 7 + 4,
        wF: rnd() * 0.012 + 0.003, wA: rnd() * 12 + 4,
        ph: rnd() * TAU,
        col: pearlColors[Math.floor(rnd() * pearlColors.length)]
      });
    }

    var sparkles = [];
    for (var i = 0; i < 28; i++) {
      var b = burst(rnd() * 8 + 4);
      sparkles.push({
        x: b.x, y: b.y, vx: b.vx, vy: b.vy,
        sz: rnd() * 8 + 3,
        wF: rnd() * 0.025 + 0.005, wA: rnd() * 16 + 4,
        ph: rnd() * TAU,
        rot: rnd() * TAU, rSpd: (rnd() - 0.5) * 0.03,
        pulse: rnd() * TAU
      });
    }

    var shellHues = [25, 35, 340, 350, 15];
    var shells = [];
    for (var i = 0; i < 10; i++) {
      var b = burst(rnd() * 4 + 2);
      shells.push({
        x: b.x, y: b.y, vx: b.vx, vy: b.vy,
        sz: rnd() * 12 + 8,
        wF: rnd() * 0.012 + 0.003, wA: rnd() * 12 + 4,
        ph: rnd() * TAU,
        rot: rnd() * TAU, rSpd: (rnd() - 0.5) * 0.012,
        hue: shellHues[Math.floor(rnd() * shellHues.length)]
      });
    }

    var starfish = [];
    for (var i = 0; i < 7; i++) {
      var b = burst(rnd() * 4 + 1.5);
      starfish.push({
        x: b.x, y: b.y, vx: b.vx, vy: b.vy,
        sz: rnd() * 10 + 7,
        wF: rnd() * 0.01 + 0.003, wA: rnd() * 10 + 4,
        ph: rnd() * TAU,
        rot: rnd() * TAU, rSpd: (rnd() - 0.5) * 0.008,
        hue: rnd() > 0.5 ? 5 : 350
      });
    }

    /* ── Draw helpers ── */
    function drawBubble(b, fade) {
      var r = b.r;
      if (b.y < h * 0.05) r *= Math.max(0, b.y / (h * 0.05));
      if (r < 0.5) return;
      var x = b.x, y = b.y;

      ctx.globalAlpha = fade * 0.4;
      var g = ctx.createRadialGradient(x - r * 0.3, y - r * 0.35, r * 0.05, x, y, r);
      g.addColorStop(0, 'rgba(255,255,255,0.6)');
      g.addColorStop(0.3, 'hsla(' + b.hue + ',70%,85%,0.2)');
      g.addColorStop(0.7, 'hsla(' + (b.hue + 20) + ',60%,80%,0.08)');
      g.addColorStop(1, 'hsla(' + b.hue + ',50%,75%,0.02)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, r, 0, TAU);
      ctx.fill();

      ctx.globalAlpha = fade * 0.25;
      ctx.strokeStyle = 'rgba(255,255,255,0.5)';
      ctx.lineWidth = Math.max(0.5, r * 0.06);
      ctx.beginPath();
      ctx.arc(x, y, r * 0.9, -1.0, 0.6);
      ctx.stroke();

      ctx.globalAlpha = fade * 0.5;
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.beginPath();
      ctx.save();
      ctx.translate(x - r * 0.28, y - r * 0.32);
      ctx.scale(1, 0.55);
      ctx.arc(0, 0, r * 0.15, 0, TAU);
      ctx.restore();
      ctx.fill();
    }

    function drawPearl(p, fade) {
      var x = p.x, y = p.y, r = p.r;
      ctx.globalAlpha = fade * 0.85;
      var g = ctx.createRadialGradient(x - r * 0.3, y - r * 0.3, r * 0.1, x, y, r);
      g.addColorStop(0, '#fff');
      g.addColorStop(0.4, p.col);
      g.addColorStop(1, 'rgba(180,160,150,0.6)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, r, 0, TAU);
      ctx.fill();

      ctx.globalAlpha = fade * 0.9;
      ctx.fillStyle = '#fff';
      ctx.beginPath();
      ctx.arc(x - r * 0.3, y - r * 0.3, r * 0.2, 0, TAU);
      ctx.fill();
    }

    function drawSparkle(s, fade, fr) {
      var shimmer = 0.5 + 0.5 * Math.sin(fr * 0.1 + s.pulse);
      var sz = s.sz * (0.6 + shimmer * 0.4);
      ctx.globalAlpha = fade * shimmer * 0.8;
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.save();
      ctx.translate(s.x, s.y);
      ctx.rotate(s.rot);
      ctx.beginPath();
      ctx.moveTo(0, -sz);
      ctx.quadraticCurveTo(sz * 0.15, -sz * 0.15, sz, 0);
      ctx.quadraticCurveTo(sz * 0.15, sz * 0.15, 0, sz);
      ctx.quadraticCurveTo(-sz * 0.15, sz * 0.15, -sz, 0);
      ctx.quadraticCurveTo(-sz * 0.15, -sz * 0.15, 0, -sz);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }

    function drawShell(sh, fade) {
      ctx.save();
      ctx.translate(sh.x, sh.y);
      ctx.rotate(sh.rot);
      ctx.globalAlpha = fade * 0.75;
      var sz = sh.sz, ridges = 7;
      for (var i = 0; i < ridges; i++) {
        var a1 = PI + (PI * i / ridges);
        var a2 = PI + (PI * (i + 1) / ridges);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.arc(0, 0, sz, a1, a2);
        ctx.closePath();
        ctx.fillStyle = 'hsla(' + sh.hue + ',35%,' + (75 + (i % 2) * 10) + '%,0.9)';
        ctx.fill();
      }
      ctx.globalAlpha = fade * 0.3;
      ctx.strokeStyle = 'rgba(255,255,255,0.5)';
      ctx.lineWidth = 0.5;
      ctx.beginPath();
      ctx.arc(0, 0, sz, PI, TAU);
      ctx.stroke();
      ctx.globalAlpha = fade * 0.5;
      ctx.fillStyle = 'hsla(' + sh.hue + ',30%,60%,0.8)';
      ctx.beginPath();
      ctx.arc(0, 0, sz * 0.12, 0, TAU);
      ctx.fill();
      ctx.restore();
    }

    function drawStarfish(sf, fade) {
      ctx.save();
      ctx.translate(sf.x, sf.y);
      ctx.rotate(sf.rot);
      ctx.globalAlpha = fade * 0.7;
      var sz = sf.sz, outer = sz, inner = sz * 0.45;
      ctx.beginPath();
      for (var i = 0; i < 10; i++) {
        var a = (i * PI / 5) - PI / 2;
        var r = i % 2 === 0 ? outer : inner;
        if (i === 0) ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r);
        else ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      ctx.closePath();
      var g = ctx.createRadialGradient(0, -sz * 0.2, 0, 0, 0, sz);
      g.addColorStop(0, 'hsla(' + sf.hue + ',55%,75%,0.9)');
      g.addColorStop(1, 'hsla(' + sf.hue + ',50%,55%,0.8)');
      ctx.fillStyle = g;
      ctx.fill();
      ctx.globalAlpha = fade * 0.4;
      ctx.fillStyle = 'hsla(' + sf.hue + ',40%,80%,0.8)';
      ctx.beginPath();
      ctx.arc(0, 0, sz * 0.15, 0, TAU);
      ctx.fill();
      ctx.restore();
    }

    /* ── Animation loop ── */
    var frame = 0, maxFrames = 300;
    function tick() {
      ctx.clearRect(0, 0, w, h);
      frame++;
      var fade = frame > maxFrames - 100 ? (maxFrames - frame) / 100 : 1;

      for (var i = 0; i < bubbles.length; i++) {
        var b = bubbles[i];
        b.vx *= friction; b.vy *= friction;
        b.x += b.vx + Math.sin(frame * b.wF + b.ph) * b.wA * 0.012;
        b.y += b.vy;
        drawBubble(b, fade);
      }
      for (var i = 0; i < shells.length; i++) {
        var s = shells[i];
        s.vx *= friction; s.vy *= friction;
        s.x += s.vx + Math.sin(frame * s.wF + s.ph) * s.wA * 0.012;
        s.y += s.vy;
        s.rot += s.rSpd;
        drawShell(s, fade);
      }
      for (var i = 0; i < starfish.length; i++) {
        var sf = starfish[i];
        sf.vx *= friction; sf.vy *= friction;
        sf.x += sf.vx + Math.sin(frame * sf.wF + sf.ph) * sf.wA * 0.012;
        sf.y += sf.vy;
        sf.rot += sf.rSpd;
        drawStarfish(sf, fade);
      }
      for (var i = 0; i < pearls.length; i++) {
        var p = pearls[i];
        p.vx *= friction; p.vy *= friction;
        p.x += p.vx + Math.sin(frame * p.wF + p.ph) * p.wA * 0.012;
        p.y += p.vy;
        drawPearl(p, fade);
      }
      for (var i = 0; i < sparkles.length; i++) {
        var sp = sparkles[i];
        sp.vx *= friction; sp.vy *= friction;
        sp.x += sp.vx + Math.sin(frame * sp.wF + sp.ph) * sp.wA * 0.012;
        sp.y += sp.vy;
        sp.rot += sp.rSpd;
        drawSparkle(sp, fade, frame);
      }

      ctx.globalAlpha = 1;
      if (frame < maxFrames) {
        confettiRaf = requestAnimationFrame(tick);
      } else {
        ctx.clearRect(0, 0, w, h);
      }
    }
    confettiRaf = requestAnimationFrame(tick);
  }

  function stopAquarium() {
    if (confettiRaf) cancelAnimationFrame(confettiRaf);
    var ctx = confettiCanvas.getContext('2d');
    ctx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
  }

  /* ─── Banner & Countdown ─── */
  function showBanner() { banner.classList.remove('promo-code__banner--hidden'); }
  function hideBanner() { banner.classList.add('promo-code__banner--hidden'); }
  function showFab() { fab.classList.remove('promo-code__fab--hidden'); }
  function hideFab() { fab.classList.add('promo-code__fab--hidden'); }

  function tickCountdown() {
    var state = readState();
    if (!state) {
      document.body.classList.remove('promo-active');
      stopCountdown();
      hideBanner();
      showFab();
      return;
    }
    var remaining = Math.max(0, Math.round((state.expiresAt - Date.now()) / 1000));
    bannerTimer.textContent = 'Scade tra ' + formatTime(remaining);
    if (remaining < URGENT_THRESHOLD_S) banner.classList.add('promo-code__banner--urgent');
    else banner.classList.remove('promo-code__banner--urgent');
    if (remaining <= 0) {
      clearState();
      stopCountdown();
      hideBanner();
      showFab();
      // Reload to clear discount markup from PLP/PDP — simplest cleanup.
      location.reload();
    }
  }

  function startCountdown() {
    stopCountdown();
    tickCountdown();
    countdownInterval = setInterval(tickCountdown, 1000);
  }

  function stopCountdown() {
    if (countdownInterval) clearInterval(countdownInterval);
    countdownInterval = null;
  }

  /* ─── Init ─── */
  function init() {
    root = document.getElementById('PromoCode');
    if (!root) return;

    fab = $('.promo-code__fab');
    backdrop = $('.promo-code__backdrop');
    drawer = $('.promo-code__drawer');
    form = $('.promo-code__form');
    input = $('.promo-code__input');
    submit = $('.promo-code__submit');
    errorEl = $('.promo-code__error');
    celebration = $('.promo-code__celebration');
    confettiCanvas = $('.promo-code__confetti');
    banner = document.querySelector('.promo-code__banner');
    bannerLabel = document.querySelector('.promo-code__banner-label');
    bannerTimer = document.querySelector('.promo-code__banner-timer');

    submit.dataset.label = submit.textContent.trim();

    fab.addEventListener('click', openDrawer);
    backdrop.addEventListener('click', closeDrawer);
    form.addEventListener('submit', function (e) { e.preventDefault(); applyCode(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('promo-code__drawer--open')) closeDrawer();
    });

    // Restore active discount across page navigations
    if (readState()) {
      document.body.classList.add('promo-active');
      hideFab();
      showBanner();
      startCountdown();
      applyDiscountDisplay();
    }

    // Re-apply overlay when Motion's PDP variant change re-renders the price.
    document.addEventListener('variantPriceChange', function () {
      if (!readState()) return;
      // Motion overwrites the price text but our `data-promo-applied` flag
      // stays on the element — clear it on PDP price elements before re-running.
      var pdpEls = document.querySelectorAll('[data-product-price],[data-compare-price]');
      for (var i = 0; i < pdpEls.length; i++) delete pdpEls[i].dataset.promoApplied;
      setTimeout(applyDiscountDisplay, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
